import React, { useState } from "react";
import "./StarRating.scss";

const DynamikStarRating = ({ setRating }) => {
  const [selectedRating, setSelectedRating] = useState(0);

  const handleClick = (selectedStar) => {
    setSelectedRating(selectedStar);
    setRating(selectedStar);
  };

  return (
    <div className="starRatingBox__">
      {[1, 2, 3, 4, 5].map((star) => (
        <span
          key={star}
          className={star <= selectedRating ? "star selected" : "star"}
          onClick={() => handleClick(star)}
        >
          &#9733;
        </span>
      ))}
    </div>
  );
};

export default DynamikStarRating;
